// @flow
import './UploadingsModal.css';

import * as React from 'react';
import LazyLoader from 'react-lazy-load';
import $ from 'jquery';
import _ from 'lodash';
import CollectionUtil from '../queries/lightbox/CollectionUtil';
import StoreListener from '../store/StoreListener';
import { SHOW_UPLOADS, ASSET_UPLOAD_JOBS, UPLOAD_FINISHED, ASSETLIST_PAGE_NUMBER } from '../store/Constants';
import Store from '../store/Store';
import AssetUploadJob from '../upload/AssetUploadJob';
import Uploading from '../uploadings/Uploading';
import Modal from '../modals/Modal2';
import CreateFolderJob from '../upload/CreateFolderJob';
import t from '../i18n/I18n';
import ConnectionUtil from "../util/session/ConnectionUtil";

type Props = {
  ASSET_UPLOAD_JOBS?: AssetUploadJob[]
};

type State = {};

const storeItems = [ASSET_UPLOAD_JOBS];

@StoreListener(storeItems)
export default class UploadingsModal extends React.Component<Props, State> {
  _isMounted = true;
  _node: ?HTMLDivElement;

  state = {};

  componentWillUnmount() {
    this._isMounted = false;
  }

  deleteFileOnRemote = (job: AssetUploadJob | CreateFolderJob) => {
    job.cancel();
    Store.put(ASSET_UPLOAD_JOBS, this.props.ASSET_UPLOAD_JOBS.filter((j) => j.id !== job.id));
    if (!job.upload) {
      return;
    }

    const __url =
      ConnectionUtil.getPreviewServerUrl() +
      '/webclient/uploadFile?action=delete&uniqueKey=' +
      job.upload.uniqueKey +
      '&name=' +
      job.upload.name;

    this.makeRemoteCall(__url);
  };

  cancelAllUploads = () => {
    this.props[ASSET_UPLOAD_JOBS].forEach((job: AssetUploadJob | CreateFolderJob) => {
      job.cancel();
      if (job.upload) {
        const __url = ConnectionUtil.getPreviewServerUrl() + '/webclient/uploadFile?action=deleteAll&uniqueKey=' + job.uniqueKey;
        this.makeRemoteCall(__url);
      }
    });

    Store.put(ASSET_UPLOAD_JOBS, []);
    this.onClose();
  };

  makeRemoteCall = (__url) => {
    //return new Promise((onSuccess, onFailure) => {
    $.ajax({
      contentType: false, //Fixed: WC-272 Improper use of jquery ajax on GET request - Om
      dataType: 'json',
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      },
      method: 'GET',
      url: __url
    })
      .done((data, textStatus, jqXHR) => {
      })
      .fail((jqXHR, textStatus, errorThrown) => {
        console.log(t('REMOTE_DELETE_FAIL'));
      })
      .always(() => {
      });
    //});
  };

  onClose = () => {
    Store.put(SHOW_UPLOADS, false);

    const allJobs = this.props.ASSET_UPLOAD_JOBS;
    const completedJobs = allJobs.filter((j) => j.done || j.canceled);
    if (completedJobs.length === allJobs.length) {
      Store.put(ASSETLIST_PAGE_NUMBER, 0); //Load Assets from page 0
      Store.put(ASSET_UPLOAD_JOBS, []);
      Store.put(UPLOAD_FINISHED, allJobs);
    }
  };

  onUploadComplete = () => {
    if (this._isMounted) {
      this.forceUpdate();
    }
  };

  renderUploading = (assetUploadJob: AssetUploadJob) => {
    const uploadingHeight = 70;
    const uploadedLabel = (
      <div className="uploaded">
        <span>{t('UPLOADING.UPLOADED')}</span>
      </div>
    );

    return (
      <LazyLoader key={assetUploadJob.id} height={60}>
        <Uploading
          job={assetUploadJob}
          uploadedLabel={uploadedLabel}
          uploadingHeight={uploadingHeight}
          deleteFileOnRemote={this.deleteFileOnRemote}
          onUploadComplete={this.onUploadComplete}
        />
      </LazyLoader>
    );
  };

  render() {
    if (CollectionUtil.isLink()) {
      return null;
    }

    const allJobs = this.props[ASSET_UPLOAD_JOBS];
    const totalImports = allJobs.length;

    const uploadedImports = allJobs.filter((job: AssetUploadJob | CreateFolderJob) => {
      if (job.upload) {
        return _.includes(['UPLOADED', 'FINISHED'], job.upload.status);
      } else {
        return job.done;
      }
    }).length;

    const finishedImports = allJobs.filter((j) => j.done);

    const progressText =
      totalImports !== uploadedImports
        ? ` - ${uploadedImports} of ${totalImports}`
        : ` - ${t('UPLOADING.FINISHED')} uploading ${totalImports} ${totalImports === 1 ? ' asset' : ' assets'}`;

    const cancelBtn = { label: t('CANCEL_ALL_UPLOADS'), onClick: this.cancelAllUploads, type: 'CANCEL' };
    const doneBtn = { label: t('DONE_LABEL'), onClick: this.onClose, type: 'CANCEL' };

    const modalProps = {
      onClose: this.onClose,
      name: 'UploadingsModal',
      title: `${t('UPLOADS_LABEL')} ${progressText}`,
      buttons: finishedImports.length === totalImports ? [doneBtn] : [cancelBtn, doneBtn]
    };

    return <Modal {...modalProps} closeOnEsc closeOnOutsideClick>{allJobs.map(this.renderUploading)}</Modal>;
  }
}
